import { injectable } from 'tsyringe';
import type { DependencyContainer } from 'tsyringe';
import type { DpProvider } from '@/core/di/DpProvider';
import {
  EmbeddedSignupLauncherToken,
  TextChannelRepositoryToken,
  WhatsAppSenderRepositoryToken,
  WhatsAppSignupConfigRepositoryToken,
} from '@/modules/settings/di/token';
import { CacheTextChannelRepository } from '@/modules/settings/adapters/channels/CacheTextChannelRepository';
import type { TextChannelRepository } from '@/modules/settings/domain/channels/TextChannelRepository';
import type { WhatsAppSenderRepository } from '@/modules/settings/domain/channels/WhatsAppSenderRepository';
import { HttpWhatsAppSenderRepository } from '@/modules/settings/adapters/channels/HttpWhatsAppSenderRepository';
import type { WhatsAppSignupConfigRepository } from '@/modules/settings/domain/channels/WhatsAppSignupConfigRepository';
import { HttpWhatsAppSignupConfigRepository } from '@/modules/settings/adapters/channels/HttpWhatsAppSignupConfigRepository';
import type { EmbeddedSignupLauncher } from '@/modules/settings/domain/channels/EmbeddedSignupLauncher';
import { FacebookEmbeddedSignupLauncher } from '@/modules/settings/adapters/channels/FacebookEmbeddedSignupLauncher';
import { DpEventBus } from '@/core/events/DpEventBus';
import { FacilityLoadedEvent } from '@/modules/facility/public/events';
import { FacilityLoadedListener } from '@/modules/settings/adapters/FacilityLoadedListener';

@injectable()
export class ChannelsProvider implements DpProvider {
  constructor(
    private readonly eventBus: DpEventBus,
    private readonly facilityLoadedListener: FacilityLoadedListener,
  ) {}

  boot(): void {
    this.eventBus.subscribe(FacilityLoadedEvent.eventName, this.facilityLoadedListener);
  }

  register(container: DependencyContainer): void {
    container.register<TextChannelRepository>(
      TextChannelRepositoryToken,
      CacheTextChannelRepository,
    );

    container.register<WhatsAppSenderRepository>(
      WhatsAppSenderRepositoryToken,
      HttpWhatsAppSenderRepository,
    );

    container.register<WhatsAppSignupConfigRepository>(
      WhatsAppSignupConfigRepositoryToken,
      HttpWhatsAppSignupConfigRepository,
    );

    container.registerSingleton<EmbeddedSignupLauncher>(
      EmbeddedSignupLauncherToken,
      FacebookEmbeddedSignupLauncher,
    );
  }
}
